import styled, { css } from 'styled-components';

export const Label = styled.span`
  color: #000;
  font-weight: bold;
  ${props =>
    props.theme === 'Dark' &&
    css`
      color: #fff;
    `}
`;

export const LabelInner = styled.span`
  ${props =>
    props.blackColor &&
    css`
      color: #000;
    `}
`;
